/**
 * Component - contactMap
 */

// @ts-nocheck

/* SETUP: Cumpelikova */
const loadCumpelikova = (map, mapIcon, component, allTabs, allContents) => {
  let adressCumpelikova = {
    lat: 50.126713,
    lng: 14.461399
  }

  let markerCumpelikova = new google.maps.Marker({
    map,
    position: adressCumpelikova,
    title: 'Pizza caffe U veverky - Čumpelíkova',
    icon: mapIcon
  })

  let infoCumpelikova = new google.maps.InfoWindow({
    content: '<div class="mapcontainer"><div class="mappicture"> </div><div class="mapcontent"> <h2>Pizza & cafe U veverky <br>Čumpelíkova <br>739 225 017</h2> <div>Čumpelíkova 1764/2<br>182 00, Praha 8 Kobylisy<br></div><br></div><br class="clr"></div>'
  })

  markerCumpelikova.addListener('click', function () {
    infoCumpelikova.open(map, markerCumpelikova)
  })

  let pathCumpelikova = [
    new google.maps.LatLng(50.1529262, 14.4432878),
    new google.maps.LatLng(50.1499289, 14.4413996),
    new google.maps.LatLng(50.1445937, 14.4426012),
    new google.maps.LatLng(50.1355171, 14.4449615),
    new google.maps.LatLng(50.1318859, 14.4480944),
    new google.maps.LatLng(50.1292174, 14.4404125),
    new google.maps.LatLng(50.1275117, 14.4345760),
    new google.maps.LatLng(50.1236873, 14.4353914),
    new google.maps.LatLng(50.1229169, 14.4363356),
    new google.maps.LatLng(50.1188721, 14.4326878),
    new google.maps.LatLng(50.1146342, 14.4334173),
    new google.maps.LatLng(50.1167532, 14.4448328),
    new google.maps.LatLng(50.1145242, 14.4493389),
    new google.maps.LatLng(50.1154598, 14.4584799),
    new google.maps.LatLng(50.1133958, 14.4625998),
    new google.maps.LatLng(50.1131206, 14.4654322),
    new google.maps.LatLng(50.1123776, 14.4691658),
    new google.maps.LatLng(50.1115519, 14.4716549),
    new google.maps.LatLng(50.1109465, 14.4735861),
    new google.maps.LatLng(50.1125977, 14.4779634),
    new google.maps.LatLng(50.1130931, 14.4831562),
    new google.maps.LatLng(50.1154323, 14.4923830),
    new google.maps.LatLng(50.1155974, 14.4954300),
    new google.maps.LatLng(50.1190647, 14.5008802),
    new google.maps.LatLng(50.1213210, 14.5046568),
    new google.maps.LatLng(50.1256683, 14.5160294),
    new google.maps.LatLng(50.1301528, 14.5210505),
    new google.maps.LatLng(50.1343067, 14.5253420),
    new google.maps.LatLng(50.1444562, 14.5338821),
    new google.maps.LatLng(50.1514963, 14.5396328),
    new google.maps.LatLng(50.1578205, 14.5317793),
    new google.maps.LatLng(50.1546035, 14.5124245),
    new google.maps.LatLng(50.1521013, 14.5064592),
    new google.maps.LatLng(50.1427785, 14.5054293),
    new google.maps.LatLng(50.1384053, 14.5039272),
    new google.maps.LatLng(50.1340316, 14.5060730),
    new google.maps.LatLng(50.1329038, 14.4983482),
    new google.maps.LatLng(50.1393405, 14.4970608),
    new google.maps.LatLng(50.1435761, 14.5008373),
    new google.maps.LatLng(50.1503964, 14.4935417),
    new google.maps.LatLng(50.1527887, 14.4859886),
    new google.maps.LatLng(50.1512763, 14.4826412),
    new google.maps.LatLng(50.1490489, 14.4788218),
    new google.maps.LatLng(50.1497914, 14.4693804),
    new google.maps.LatLng(50.1522113, 14.4582224),
    new google.maps.LatLng(50.1528987, 14.4433737)
  ]

  let polygonCumpelikova = new google.maps.Polygon({
    paths: pathCumpelikova,
    strokeColor: '#FF0000',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#FF0000',
    fillOpacity: 0.35
  })

  polygonCumpelikova.setMap(map)
}

/* SETUP: Olstynska */
const loadOlstynska = (map, mapIcon, component, allTabs, allContents) => {
  const zoneID = 'yellow'

  const directButton = component.querySelector(`.js-contactMap__instantCTA[data-zone="${zoneID}"]`)

  const infoWrapper = component.querySelector('.js-contactMap__info')

  const tab = component.querySelector(`.js-contactMap__infoTab[data-zone="${zoneID}"]`)
  const infoContent = component.querySelector(`.js-contactMap__infoContent[data-zone="${zoneID}"]`)

  let adressOlstynska = {
    lat: 50.127660,
    lng: 14.419900
  }

  let markerOlstynska = new google.maps.Marker({
    map,
    position: adressOlstynska,
    title: 'Pizza caffe U veverky - Olštýnská',
    icon: mapIcon
  })

  let pathOlstynska = [
    new google.maps.LatLng(50.136805, 14.3933171),
    new google.maps.LatLng(50.1360897, 14.3932526),
    new google.maps.LatLng(50.1351132, 14.3940465),
    new google.maps.LatLng(50.1346867, 14.3944757),
    new google.maps.LatLng(50.1343979, 14.3949263),
    new google.maps.LatLng(50.1341915, 14.3950765),
    new google.maps.LatLng(50.1339026, 14.3954843),
    new google.maps.LatLng(50.1328297, 14.397394),
    new google.maps.LatLng(50.1319494, 14.3986816),
    new google.maps.LatLng(50.1305051, 14.4008488),
    new google.maps.LatLng(50.1287032, 14.4016856),
    new google.maps.LatLng(50.1267084, 14.4009776),
    new google.maps.LatLng(50.124246, 14.3987244),
    new google.maps.LatLng(50.1233379, 14.3979948),
    new google.maps.LatLng(50.1219347, 14.3972009),
    new google.maps.LatLng(50.1207239, 14.3972223),
    new google.maps.LatLng(50.1194994, 14.3975442),
    new google.maps.LatLng(50.1187151, 14.3981879),
    new google.maps.LatLng(50.1177933, 14.3990249),
    new google.maps.LatLng(50.118825, 14.399304),
    new google.maps.LatLng(50.1193341, 14.4003929),
    new google.maps.LatLng(50.1199533, 14.4039496),
    new google.maps.LatLng(50.1194511, 14.4062134),
    new google.maps.LatLng(50.1190796, 14.4071468),
    new google.maps.LatLng(50.1177794, 14.4090031),
    new google.maps.LatLng(50.1175593, 14.4114278),
    new google.maps.LatLng(50.115688, 14.411063),
    new google.maps.LatLng(50.1158256, 14.4119642),
    new google.maps.LatLng(50.1158944, 14.413123),
    new google.maps.LatLng(50.1159769, 14.4147538),
    new google.maps.LatLng(50.114711, 14.4171786),
    new google.maps.LatLng(50.1140781, 14.4198823),
    new google.maps.LatLng(50.1131148, 14.4246032),
    new google.maps.LatLng(50.1124268, 14.4291738),
    new google.maps.LatLng(50.1123993, 14.4318131),
    new google.maps.LatLng(50.1128121, 14.4346026),
    new google.maps.LatLng(50.1136033, 14.4320491),
    new google.maps.LatLng(50.1140573, 14.4320492),
    new google.maps.LatLng(50.114078, 14.433326),
    new google.maps.LatLng(50.1142088, 14.4336157),
    new google.maps.LatLng(50.1154248, 14.4334655),
    new google.maps.LatLng(50.1159735, 14.4332187),
    new google.maps.LatLng(50.1149036, 14.435268),
    new google.maps.LatLng(50.1149243, 14.439581),
    new google.maps.LatLng(50.1158462, 14.4417483),
    new google.maps.LatLng(50.1159047, 14.4429393),
    new google.maps.LatLng(50.1159425, 14.4440552),
    new google.maps.LatLng(50.1160079, 14.4449939),
    new google.maps.LatLng(50.1161558, 14.4455894),
    new google.maps.LatLng(50.1173942, 14.4463619),
    new google.maps.LatLng(50.1156674, 14.4477674),
    new google.maps.LatLng(50.1147489, 14.4484701),
    new google.maps.LatLng(50.1144479, 14.4491863),
    new google.maps.LatLng(50.1144152, 14.451383),
    new google.maps.LatLng(50.117009, 14.4511685),
    new google.maps.LatLng(50.1182197, 14.4516192),
    new google.maps.LatLng(50.1179583, 14.4544731),
    new google.maps.LatLng(50.1178207, 14.4563185),
    new google.maps.LatLng(50.1177794, 14.4584214),
    new google.maps.LatLng(50.1145046, 14.4568764),
    new google.maps.LatLng(50.1132937, 14.4592798),
    new google.maps.LatLng(50.1128258, 14.4618548),
    new google.maps.LatLng(50.113273, 14.4643761),
    new google.maps.LatLng(50.1134828, 14.465626),
    new google.maps.LatLng(50.1131336, 14.4658218),
    new google.maps.LatLng(50.1134131, 14.4673145),
    new google.maps.LatLng(50.1132867, 14.4678093),
    new google.maps.LatLng(50.1133658, 14.4689413),
    new google.maps.LatLng(50.1131276, 14.4689346),
    new google.maps.LatLng(50.1135462, 14.4692092),
    new google.maps.LatLng(50.1138823, 14.4693765),
    new google.maps.LatLng(50.1139077, 14.4697969),
    new google.maps.LatLng(50.1137383, 14.4701604),
    new google.maps.LatLng(50.1132693, 14.471029),
    new google.maps.LatLng(50.1132889, 14.4726702),
    new google.maps.LatLng(50.1124519, 14.4718866),
    new google.maps.LatLng(50.1121985, 14.4706581),
    new google.maps.LatLng(50.111831, 14.4707519),
    new google.maps.LatLng(50.1115097, 14.4704555),
    new google.maps.LatLng(50.1117825, 14.4637411),
    new google.maps.LatLng(50.111663, 14.4629921),
    new google.maps.LatLng(50.1111762, 14.4629385),
    new google.maps.LatLng(50.1108821, 14.4635071),
    new google.maps.LatLng(50.1102783, 14.464269),
    new google.maps.LatLng(50.1095498, 14.4656691),
    new google.maps.LatLng(50.1097984, 14.4668439),
    new google.maps.LatLng(50.109874, 14.4677398),
    new google.maps.LatLng(50.1091894, 14.4694538),
    new google.maps.LatLng(50.109358, 14.4713501),
    new google.maps.LatLng(50.1094061, 14.4723801),
    new google.maps.LatLng(50.1099325, 14.4726322),
    new google.maps.LatLng(50.1108494, 14.4737024),
    new google.maps.LatLng(50.1116106, 14.4752675),
    new google.maps.LatLng(50.1121722, 14.4783667),
    new google.maps.LatLng(50.1129015, 14.4810705),
    new google.maps.LatLng(50.113163, 14.482594),
    new google.maps.LatLng(50.1133968, 14.4827873),
    new google.maps.LatLng(50.1134588, 14.4847613),
    new google.maps.LatLng(50.1143189, 14.4868859),
    new google.maps.LatLng(50.1146526, 14.4883504),
    new google.maps.LatLng(50.1153784, 14.490641),
    new google.maps.LatLng(50.1156501, 14.4924166),
    new google.maps.LatLng(50.115461, 14.4939562),
    new google.maps.LatLng(50.1159288, 14.4955443),
    new google.maps.LatLng(50.1160527, 14.4960699),
    new google.maps.LatLng(50.1160114, 14.4963275),
    new google.maps.LatLng(50.1159082, 14.5003079),
    new google.maps.LatLng(50.116713, 14.5006942),
    new google.maps.LatLng(50.1176521, 14.5003724),
    new google.maps.LatLng(50.1181285, 14.499836),
    new google.maps.LatLng(50.1188388, 14.501381),
    new google.maps.LatLng(50.1193067, 14.5024754),
    new google.maps.LatLng(50.1203317, 14.5024647),
    new google.maps.LatLng(50.1209955, 14.5037897),
    new google.maps.LatLng(50.1218244, 14.5054044),
    new google.maps.LatLng(50.122416, 14.5064558),
    new google.maps.LatLng(50.123042, 14.5075395),
    new google.maps.LatLng(50.1241838, 14.5088753),
    new google.maps.LatLng(50.1252088, 14.5090631),
    new google.maps.LatLng(50.1255045, 14.5083979),
    new google.maps.LatLng(50.1260789, 14.5088214),
    new google.maps.LatLng(50.1292154, 14.5128556),
    new google.maps.LatLng(50.128225, 14.5066758),
    new google.maps.LatLng(50.1293823, 14.5047118),
    new google.maps.LatLng(50.1325185, 14.4995623),
    new google.maps.LatLng(50.1416512, 14.4969023),
    new google.maps.LatLng(50.1455019, 14.4970738),
    new google.maps.LatLng(50.1493522, 14.4940695),
    new google.maps.LatLng(50.1508371, 14.4939835),
    new google.maps.LatLng(50.1519371, 14.4915793),
    new google.maps.LatLng(50.1585088, 14.4828674),
    new google.maps.LatLng(50.1608044, 14.4785529),
    new google.maps.LatLng(50.1452819, 14.46849),
    new google.maps.LatLng(50.147537, 14.4562159),
    new google.maps.LatLng(50.148471, 14.4502089),
    new google.maps.LatLng(50.1538746, 14.4511101),
    new google.maps.LatLng(50.1531597, 14.4474623),
    new google.maps.LatLng(50.1526648, 14.4450805),
    new google.maps.LatLng(50.152046, 14.4440504),
    new google.maps.LatLng(50.151936, 14.4421835),
    new google.maps.LatLng(50.1518672, 14.4400806),
    new google.maps.LatLng(50.1517985, 14.4377846),
    new google.maps.LatLng(50.1519772, 14.4366044),
    new google.maps.LatLng(50.1496949, 14.4369691),
    new google.maps.LatLng(50.1479211, 14.4358747),
    new google.maps.LatLng(50.1482373, 14.4351237),
    new google.maps.LatLng(50.1478797, 14.4324844),
    new google.maps.LatLng(50.147866, 14.4317334),
    new google.maps.LatLng(50.1450884, 14.4314329),
    new google.maps.LatLng(50.1446621, 14.4283644),
    new google.maps.LatLng(50.1443733, 14.4261971),
    new google.maps.LatLng(50.1454183, 14.4240513),
    new google.maps.LatLng(50.1439882, 14.4217014),
    new google.maps.LatLng(50.1433556, 14.4209612),
    new google.maps.LatLng(50.1421316, 14.4180858),
    new google.maps.LatLng(50.1407839, 14.4203389),
    new google.maps.LatLng(50.1408146, 14.4223764),
    new google.maps.LatLng(50.140316, 14.4224243),
    new google.maps.LatLng(50.1398071, 14.4224941),
    new google.maps.LatLng(50.1396782, 14.4221588),
    new google.maps.LatLng(50.1396868, 14.4214373),
    new google.maps.LatLng(50.1395029, 14.4204957),
    new google.maps.LatLng(50.1392554, 14.4204045),
    new google.maps.LatLng(50.1399911, 14.4160163),
    new google.maps.LatLng(50.1401286, 14.4146537),
    new google.maps.LatLng(50.1398981, 14.4135076),
    new google.maps.LatLng(50.139998, 14.4102498),
    new google.maps.LatLng(50.139265, 14.4091491),
    new google.maps.LatLng(50.1393657, 14.4066874),
    new google.maps.LatLng(50.1391226, 14.4046548),
    new google.maps.LatLng(50.1381255, 14.4048587),
    new google.maps.LatLng(50.1373828, 14.4061891),
    new google.maps.LatLng(50.1371101, 14.4057977),
    new google.maps.LatLng(50.1372683, 14.4037484),
    new google.maps.LatLng(50.1377496, 14.4016992),
    new google.maps.LatLng(50.1376465, 14.3998537),
    new google.maps.LatLng(50.1375296, 14.3980084),
    new google.maps.LatLng(50.1377153, 14.3980405),
    new google.maps.LatLng(50.1379559, 14.3981906),
    new google.maps.LatLng(50.1384648, 14.398169),
    new google.maps.LatLng(50.1408201, 14.3993277),
    new google.maps.LatLng(50.1415799, 14.3986734),
    new google.maps.LatLng(50.1415386, 14.3982818),
    new google.maps.LatLng(50.1405072, 14.3973484),
    new google.maps.LatLng(50.1387469, 14.3954011),
    new google.maps.LatLng(50.1381693, 14.3944678),
    new google.maps.LatLng(50.136805, 14.3933171)
  ]

  let polygonOlstynska = new google.maps.Polygon({
    paths: pathOlstynska,
    strokeColor: '#FF0000',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#FF0000',
    fillOpacity: 0.35
  })

  polygonOlstynska.setMap(map)

  const openInfoPannel = () => {
    infoWrapper.classList.add('-active')

    allTabs.forEach((single: HTMLElement) => {
      single.classList.remove('-active')
    })
    allContents.forEach((single: HTMLElement) => {
      single.classList.remove('-active')
    })

    tab.classList.add('-active')
    infoContent.classList.add('-active')

    const windowWidth = window.innerWidth
    const headerHeight = (jQuery('header')) ? jQuery('header').height() : 0
    const scrollTarget = jQuery(infoWrapper)

    if (windowWidth <= 1024) {
      jQuery('html, body').animate({
        scrollTop: scrollTarget.offset().top - headerHeight
      }, 800)
    }
  }

  polygonOlstynska.addListener('click', function () {
    openInfoPannel()
  })

  markerOlstynska.addListener('click', function () {
    openInfoPannel()
  })

  tab.addEventListener('click', function () {
    openInfoPannel()
  })

  directButton.addEventListener('click', function () {
    openInfoPannel()
  })
}

/* SETUP: Waltariho */
const loadWaltariho = (map, mapIcon, component, allTabs, allContents) => {
  let waltariho = {
    lat: 50.1085752,
    lng: 14.5233454
  }

  let markerWaltariho = new google.maps.Marker({
    map,
    position: waltariho,
    title: 'Pizza caffe U veverky - Hloubětín',
    icon: mapIcon
  })

  let infoWaltariho = new google.maps.InfoWindow({
    content: '<div class="mapcontainer"><div class="mappicture"> </div><div class="mapcontent"> <h2>Pizza & cafe U veverky <br>Hloubětín<br>603 261 747</h2> <div>Waltariho 1148/1<br>198 00, Praha 9<br></div><br><br></div><br class="clr"></div>'
  })
  markerWaltariho.addListener('click', function () {
    infoWaltariho.open(map, markerWaltariho)
  })
  let pathHloubetin = [

    new google.maps.LatLng(50.1247054, 14.5131969),
    new google.maps.LatLng(50.1232196, 14.5095921),
    new google.maps.LatLng(50.1227793, 14.5077896),
    new google.maps.LatLng(50.1160652, 14.4944000),
    new google.maps.LatLng(50.1165606, 14.4883919),
    new google.maps.LatLng(50.1169458, 14.4774055),
    new google.maps.LatLng(50.1143315, 14.4747448),
    new google.maps.LatLng(50.1120198, 14.4706678),
    new google.maps.LatLng(50.1107263, 14.4771910),
    new google.maps.LatLng(50.1032948, 14.4840574),
    new google.maps.LatLng(50.1007348, 14.5071459),
    new google.maps.LatLng(50.1046436, 14.5064592),
    new google.maps.LatLng(50.1056620, 14.5201063),
    new google.maps.LatLng(50.1045610, 14.5276594),
    new google.maps.LatLng(50.1005696, 14.5309210),
    new google.maps.LatLng(50.0999365, 14.5358562),
    new google.maps.LatLng(50.1025516, 14.5426798),
    new google.maps.LatLng(50.1026066, 14.5558977),
    new google.maps.LatLng(50.1062675, 14.5564985),
    new google.maps.LatLng(50.1072309, 14.5522499),
    new google.maps.LatLng(50.1126528, 14.5695019),
    new google.maps.LatLng(50.1165055, 14.5673132),
    new google.maps.LatLng(50.1164230, 14.5597601),
    new google.maps.LatLng(50.1103410, 14.5492458),
    new google.maps.LatLng(50.1114143, 14.5336676),
    new google.maps.LatLng(50.1181841, 14.5189476),
    new google.maps.LatLng(50.1246778, 14.5132828)
  ]

  let hloubetin = new google.maps.Polygon({
    paths: pathHloubetin,
    strokeColor: '#FF0FF0',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#FF0FF0',
    fillOpacity: 0.35
  })
  hloubetin.setMap(map)
}

/* SETUP: Cumpelikova & Waltariho Hybrid */
const loadCumpelikovaWaltarihoHybrid = (map, mapIcon, component, allTabs, allContents) => {
  const zoneID = 'red'

  const directButton = component.querySelector(`.js-contactMap__instantCTA[data-zone="${zoneID}"]`)

  const infoWrapper = component.querySelector('.js-contactMap__info')

  const tab = component.querySelector(`.js-contactMap__infoTab[data-zone="${zoneID}"]`)
  const infoContent = component.querySelector(`.js-contactMap__infoContent[data-zone="${zoneID}"]`)

  let adressCumpelikova = {
    lat: 50.126713,
    lng: 14.461399
  }

  let markerCumpelikova = new google.maps.Marker({
    map,
    position: adressCumpelikova,
    title: 'Pizza caffe U veverky - Čumpelíkova',
    icon: mapIcon
  })

  let pathCumpelikova = [
    new google.maps.LatLng(50.1529262, 14.4432878),
    new google.maps.LatLng(50.1499289, 14.4413996),
    new google.maps.LatLng(50.1445937, 14.4426012),
    new google.maps.LatLng(50.1355171, 14.4449615),
    new google.maps.LatLng(50.1318859, 14.4480944),
    new google.maps.LatLng(50.1292174, 14.4404125),
    new google.maps.LatLng(50.1275117, 14.4345760),
    new google.maps.LatLng(50.1236873, 14.4353914),
    new google.maps.LatLng(50.1229169, 14.4363356),
    new google.maps.LatLng(50.1188721, 14.4326878),
    new google.maps.LatLng(50.1146342, 14.4334173),
    new google.maps.LatLng(50.1167532, 14.4448328),
    new google.maps.LatLng(50.1145242, 14.4493389),
    new google.maps.LatLng(50.1154598, 14.4584799),
    new google.maps.LatLng(50.1133958, 14.4625998),
    new google.maps.LatLng(50.1131206, 14.4654322),
    new google.maps.LatLng(50.1107263, 14.4771910),
    new google.maps.LatLng(50.1032948, 14.4840574),
    new google.maps.LatLng(50.1007348, 14.5071459),
    new google.maps.LatLng(50.1046436, 14.5064592),
    new google.maps.LatLng(50.1056620, 14.5201063),
    new google.maps.LatLng(50.1045610, 14.5276594),
    new google.maps.LatLng(50.1005696, 14.5309210),
    new google.maps.LatLng(50.0999365, 14.5358562),
    new google.maps.LatLng(50.1025516, 14.5426798),
    new google.maps.LatLng(50.1026066, 14.5558977),
    new google.maps.LatLng(50.1062675, 14.5564985),
    new google.maps.LatLng(50.1072309, 14.5522499),
    new google.maps.LatLng(50.1126528, 14.5695019),
    new google.maps.LatLng(50.1165055, 14.5673132),
    new google.maps.LatLng(50.1164230, 14.5597601),
    new google.maps.LatLng(50.1103410, 14.5492458),
    new google.maps.LatLng(50.1114143, 14.5336676),
    new google.maps.LatLng(50.1181841, 14.5189476),
    new google.maps.LatLng(50.1246778, 14.5132828),
    new google.maps.LatLng(50.1301528, 14.5210505),
    new google.maps.LatLng(50.1343067, 14.5253420),
    new google.maps.LatLng(50.1444562, 14.5338821),
    new google.maps.LatLng(50.1514963, 14.5396328),
    new google.maps.LatLng(50.1578205, 14.5317793),
    new google.maps.LatLng(50.1546035, 14.5124245),
    new google.maps.LatLng(50.1521013, 14.5064592),
    new google.maps.LatLng(50.1427785, 14.5054293),
    new google.maps.LatLng(50.1384053, 14.5039272),
    new google.maps.LatLng(50.1340316, 14.5060730),
    new google.maps.LatLng(50.1329038, 14.4983482),
    new google.maps.LatLng(50.1393405, 14.4970608),
    new google.maps.LatLng(50.1435761, 14.5008373),
    new google.maps.LatLng(50.1503964, 14.4935417),
    new google.maps.LatLng(50.1527887, 14.4859886),
    new google.maps.LatLng(50.1512763, 14.4826412),
    new google.maps.LatLng(50.1490489, 14.4788218),
    new google.maps.LatLng(50.1497914, 14.4693804),
    new google.maps.LatLng(50.1522113, 14.4582224),
    new google.maps.LatLng(50.1528987, 14.4433737)

  ]

  let polygonCumpelikova = new google.maps.Polygon({
    paths: pathCumpelikova,
    strokeColor: '#941b28',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#941b28',
    fillOpacity: 0.5
  })

  polygonCumpelikova.setMap(map)

  const openInfoPannel = () => {
    infoWrapper.classList.add('-active')

    allTabs.forEach((single: HTMLElement) => {
      single.classList.remove('-active')
    })
    allContents.forEach((single: HTMLElement) => {
      single.classList.remove('-active')
    })

    tab.classList.add('-active')
    infoContent.classList.add('-active')

    const windowWidth = window.innerWidth
    const headerHeight = (jQuery('header')) ? jQuery('header').height() : 0
    const scrollTarget = jQuery(infoWrapper)

    if (windowWidth <= 1024) {
      jQuery('html, body').animate({
        scrollTop: scrollTarget.offset().top - headerHeight
      }, 800)
    }
  }

  polygonCumpelikova.addListener('click', function () {
    openInfoPannel()
  })

  markerCumpelikova.addListener('click', function () {
    openInfoPannel()
  })

  tab.addEventListener('click', function () {
    openInfoPannel()
  })

  directButton.addEventListener('click', function () {
    openInfoPannel()
  })
}

const loadOlstynskaBackup = (map, mapIcon, component, allTabs, allContents) => {
  const zoneID = 'yellow'

  const directButton = component.querySelector(`.js-contactMap__instantCTA[data-zone="${zoneID}"]`)

  const infoWrapper = component.querySelector('.js-contactMap__info')

  const tab = component.querySelector(`.js-contactMap__infoTab[data-zone="${zoneID}"]`)
  const infoContent = component.querySelector(`.js-contactMap__infoContent[data-zone="${zoneID}"]`)

  let adressOlstynska = {
    lat: 50.127660,
    lng: 14.419900
  }

  let markerOlstynska = new google.maps.Marker({
    map,
    position: adressOlstynska,
    title: 'Pizza caffe U veverky - Olštýnská',
    icon: mapIcon
  })

  let pathOlstynska = [
    new google.maps.LatLng(50.14096627357049, 14.420372815836572),
    new google.maps.LatLng(50.140086121960785, 14.41642460416665),
    new google.maps.LatLng(50.13964604008334, 14.406468244303369),
    new google.maps.LatLng(50.13706047729382, 14.405781598795556),
    new google.maps.LatLng(50.13414467502613, 14.403120847452783),
    new google.maps.LatLng(50.13243912341258, 14.401661725748681),
    new google.maps.LatLng(50.13051342755838, 14.406639905680322),
    new google.maps.LatLng(50.129137883074584, 14.406639905680322),
    new google.maps.LatLng(50.12627662389992, 14.406897397745752),
    new google.maps.LatLng(50.12225956757931, 14.406983228434228),
    new google.maps.LatLng(50.118847556357906, 14.409901471842431),
    new google.maps.LatLng(50.11637094429059, 14.41393551420083),
    new google.maps.LatLng(50.11675620347093, 14.434105725992822),
    new google.maps.LatLng(50.12088378586261, 14.453417630900049),
    new google.maps.LatLng(50.1228648990085, 14.454275937784814),
    new google.maps.LatLng(50.12677185407507, 14.452816816080713),
    new google.maps.LatLng(50.13337443343818, 14.453589292277002),
    new google.maps.LatLng(50.146521856862236, 14.450284810770654),
    new google.maps.LatLng(50.1470718795077, 14.446422429789209),
    new google.maps.LatLng(50.146576859411454, 14.441615911234521),
    new google.maps.LatLng(50.146686864320046, 14.43363365720620)
  ]

  let polygonOlstynska = new google.maps.Polygon({
    paths: pathOlstynska,
    strokeColor: '#e7c676',
    strokeOpacity: 1,
    strokeWeight: 2,
    fillColor: '#e7c676',
    fillOpacity: 0.5
  })

  polygonOlstynska.setMap(map)

  const openInfoPannel = () => {
    infoWrapper.classList.add('-active')

    allTabs.forEach((single: HTMLElement) => {
      single.classList.remove('-active')
    })
    allContents.forEach((single: HTMLElement) => {
      single.classList.remove('-active')
    })

    tab.classList.add('-active')
    infoContent.classList.add('-active')

    const windowWidth = window.innerWidth
    const headerHeight = (jQuery('header')) ? jQuery('header').height() : 0
    const scrollTarget = jQuery(infoWrapper)

    if (windowWidth <= 1024) {
      jQuery('html, body').animate({
        scrollTop: scrollTarget.offset().top - headerHeight
      }, 800)
    }
  }

  polygonOlstynska.addListener('click', function () {
    openInfoPannel()
  })

  markerOlstynska.addListener('click', function () {
    openInfoPannel()
  })

  tab.addEventListener('click', function () {
    openInfoPannel()
  })

  directButton.addEventListener('click', function () {
    openInfoPannel()
  })
}

export const contactMap = (): void => { // Run the script for each individual component found on the page
  const componentSelector = document.querySelectorAll('.js-contactMap') as unknown as HTMLElement[]
  componentSelector.forEach((component: HTMLElement) => {
    const mapDiv = component.querySelector('.js-contactMap__inner')

    const mapIcon = component.dataset.icon

    let adressCenter = {
      lat: 50.126713,
      lng: 14.461399
    }

    let map = new google.maps.Map(mapDiv, {
      center: adressCenter,
      scrollwheel: false,
      panControl: false,
      scaleControl: false,
      streetViewControl: false,
      zoom: 13,
      styles: [
        {
          featureType: 'water',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#d3d3d3'
            }
          ]
        },
        {
          featureType: 'transit',
          stylers: [
            {
              color: '#808080'
            },
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [
            {
              visibility: 'on'
            },
            {
              color: '#b3b3b3'
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#ffffff'
            }
          ]
        },
        {
          featureType: 'road.local',
          elementType: 'geometry.fill',
          stylers: [
            {
              visibility: 'on'
            },
            {
              color: '#ffffff'
            },
            {
              weight: 1.8
            }
          ]
        },
        {
          featureType: 'road.local',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '#d7d7d7'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'geometry.fill',
          stylers: [
            {
              visibility: 'on'
            },
            {
              color: '#ebebeb'
            }
          ]
        },
        {
          featureType: 'administrative',
          elementType: 'geometry',
          stylers: [
            {
              color: '#a7a7a7'
            }
          ]
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#ffffff'
            }
          ]
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#ffffff'
            }
          ]
        },
        {
          featureType: 'landscape',
          elementType: 'geometry.fill',
          stylers: [
            {
              visibility: 'on'
            },
            {
              color: '#efefef'
            }
          ]
        },
        {
          featureType: 'road',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#696969'
            }
          ]
        },
        {
          featureType: 'administrative',
          elementType: 'labels.text.fill',
          stylers: [
            {
              visibility: 'on'
            },
            {
              color: '#737373'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'labels',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '#d6d6d6'
            }
          ]
        },
        {
          featureType: 'road',
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {},
        {
          featureType: 'poi',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#dadada'
            }
          ]
        }
      ]
    })

    const allTabs = component.querySelectorAll('.js-contactMap__infoTab')
    const allContents = component.querySelectorAll('.js-contactMap__infoContent')

    // loadCumpelikova(map, mapIcon, component, allTabs, allContents)
    loadOlstynska(map, mapIcon, component, allTabs, allContents)
    // loadWaltariho(map, mapIcon, component, allTabs, allContents)
    // loadCumpelikovaWaltarihoHybrid(map, mapIcon, component, allTabs, allContents)
  })
}
